<template>
  <header
    class="bg-linear-to-r from-blue-400 to-green-400 dark:from-slate-800 dark:to-slate-700 text-white fixed top-0 z-50 transition-all duration-300"
    :style="{
      marginLeft: layoutStore.isExpanded ? '256px' : '72px',
      width: `calc(100% - ${layoutStore.isExpanded ? '256px' : '72px'})`,
    }"
  >
    <div class="px-2 py-1 flex items-center">
      <div class="grow-1">
        <button class="px-2 py-1 cursor-pointer border-2 border-transparent rounded-md hover:border-white" @click="userStore.setTenant(null)">{{ userStore.tenant }}</button>
      </div>
      <SeedMovementData
        v-if="isDev"
      />
      <!-- Rechte Seite -->
      <div class="flex items-center space-x-4">
        <!-- Dark Mode Toggle -->
        <button
          class="p-2 rounded-lg hover:bg-white/10 transition-colors duration-200"
          :title="themeStore.isDarkMode ? t('common.lightMode') : t('common.darkMode')"
          @click="themeStore.toggleDarkMode"
        >
          <svg
            v-if="themeStore.isDarkMode"
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
          <svg
            v-else
            class="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
            />
          </svg>
        </button>
        <!-- Sprachauswahl -->
        <div class="flex items-center space-x-2">
          <span class="w-5 h-5" v-html="getCurrentFlag()"></span>
          <select
            v-model="currentLanguage"
            class="bg-transparent text-white border-none cursor-pointer focus:outline-hidden"
            @change="handleLanguageChange"
          >
            <option v-for="lang in languages" :key="lang.code" :value="lang.code" class="text-black">
              {{ lang.code.toUpperCase() }}
            </option>
          </select>
        </div>

        <!-- Sitzungsende -->
        <!-- <div 
          class="flex items-center space-x-2 cursor-help"
          title="Der Timer startet nach 30 Sekunden Inaktivität und zählt dann die verbleibende Sitzungszeit"
        >
          <span class="text-sm">{{ t('common.sessionEnd') }}</span>
          <div class="flex space-x-1">
            <span class="bg-white text-gray-800 px-2 py-0.5 rounded-sm">
              {{ formatTime(remainingTime).minutes }}:{{ formatTime(remainingTime).seconds }}
            </span>
          </div>
        </div> -->
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { AuthService } from '@/services/authService'
import * as Icons from 'country-flag-icons/string/3x2'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { useLayoutStore } from '../stores/layout'
import { useSettingsStore } from '../stores/settingsStore'
import { useThemeStore } from '../stores/themeStore'
import { useUserStore } from '@/stores/user'
import SeedMovementData from '@/components/dangerous/SeedMovementData.vue'

const router = useRouter()
const route = useRoute()
const { t, locale } = useI18n()
const layoutStore = useLayoutStore()
const settingsStore = useSettingsStore()
const themeStore = useThemeStore()

const userStore = useUserStore();

// Initialize language from URL or localStorage
const urlLang = route.params.lang as string
const storedLang = localStorage.getItem('locale') || 'de'
const initialLang = urlLang || storedLang
locale.value = initialLang
const currentLanguage = ref(initialLang)

const isDev = window.location.host.startsWith('localhost') || window.location.host === 'dev-biona.intern.vta-software.de' || userStore.user?.login.toUpperCase() === 'ERIK.VANTILBURG@VTA-SOFTWARE.DE';

// Timer logic
// const remainingTime = ref(authService.getRemainingTime())
// const timer = ref<number | null>(null)
// const inactivityDelay = 30 * 1000 // 30 Sekunden
// let inactivityTimeout: number | null = null

// const updateRemainingTime = async () => {
//   const remaining = authService.getRemainingTime()
//   remainingTime.value = remaining
  
//   // Wenn die Zeit abgelaufen ist, Timer stoppen und ausloggen
//   if (remaining <= 0 && timer.value) {
//     clearInterval(timer.value)
//     timer.value = null
//     await authService.logout()
//     router.push('/login')
//   }
// }

// const resetInactivityTimer = () => {
//   // Bestehenden Timeout und Timer löschen
//   if (inactivityTimeout) {
//     clearTimeout(inactivityTimeout)
//   }
//   if (timer.value) {
//     clearInterval(timer.value)
//     timer.value = null
//   }
  
//   // Neuen Timeout setzen
//   inactivityTimeout = window.setTimeout(() => {
//     updateRemainingTime()
//     timer.value = window.setInterval(updateRemainingTime, 1000)
//   }, inactivityDelay)
// }

// onMounted(() => {
//   // Event-Listener für Benutzeraktivität
//   const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart']
//   events.forEach(event => {
//     window.addEventListener(event, resetInactivityTimer)
//   })
  
//   // Initial Timer starten
//   resetInactivityTimer()
// })

// onBeforeUnmount(() => {
//   // Timer und Event-Listener aufräumen
//   if (timer.value) {
//     clearInterval(timer.value)
//     timer.value = null
//   }
//   if (inactivityTimeout) {
//     clearTimeout(inactivityTimeout)
//   }
  
//   // Event-Listener entfernen
//   const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart']
//   events.forEach(event => {
//     window.removeEventListener(event, resetInactivityTimer)
//   })
// })

const formatTime = (ms: number) => {
  const totalSeconds = Math.floor(ms / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  
  return {
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0')
  }
}

const handleLanguageChange = async (event: Event) => {
  try {
    const select = event.target as HTMLSelectElement
    if (!select) return

    const newLocale = select.value
    
    // Save current route
    const currentPath = router.currentRoute.value.path
    
    // Change language
    locale.value = newLocale
    localStorage.setItem('locale', newLocale)
    currentLanguage.value = newLocale
    
    // Save settings
    await settingsStore.saveSettings({
      ...settingsStore.settings,
      language: newLocale
    })
    
    // Create new URL with language prefix
    const newPath = currentPath.replace(/^\/(de|en)/, `/${newLocale}`)
    
    // Navigate to new URL and reload page
    await router.push(newPath)
    window.location.reload()
  } catch (error) {
    console.error('Error changing language:', error)
  }
}

const getCurrentFlag = () => {
  return languages.find((lang) => lang.code === currentLanguage.value)?.flag || Icons.GB
}

const languages = [
  { code: 'de', flag: Icons.DE },
  { code: 'en', flag: Icons.GB }
]

// Watch für Sprachänderungen
watch(locale, () => {
  // Keine Links mehr zu aktualisieren
})
</script>

<style scoped>
.flag-icon {
  width: 100%;
  height: 100%;
}
.flag-icon :deep(svg) {
  width: 100%;
  height: 100%;
}
</style>
